import React, { useContext, useMemo } from 'react';
import {
	EditSubCategoryContext,
	IEditSubCategoryContext,
} from '../../../../editSubCategoryState/editSubCategoryContext';
import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import InputFields from './InputFields/InputFields';
import classNames from 'classnames';
import style from './EditForm.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '18:13',
		optimalResolutions: {
			a: '324*234px',
			b: '648*468px',
		},
	},
	vertical: {
		ratio: '25:13',
		optimalResolutions: {
			a: '500*260px',
			b: '1000*520px',
		},
	},
};

interface IProps {
	isVisible: boolean;
}

const EditForm: React.FC<IProps> = ({ isVisible }) => {
	const { deletePhoto, setFileId, fileId, filePath, preSignedUrl, subCategoryID } =
		useContext<IEditSubCategoryContext>(EditSubCategoryContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const loadFromFilePathOptions = useMemo(
		() => ({
			filePath,
			preSignedUrl,
			entityID: subCategoryID,
		}),
		[filePath, preSignedUrl, subCategoryID],
	);

	return (
		<div className={containerClasses} data-test="EditForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				loadFromFilePathOptions={loadFromFilePathOptions}
				deletePhotoHandler={deletePhoto}
				setFileId={setFileId}
				horizontalAspectRatio={324 / 234}
				verticalAspectRatio={500 / 260}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
			/>
			<InputFields />
		</div>
	);
};

export default EditForm;
